import type { Appearance } from '@/hooks/use-appearance';
import { Moon, Sun } from 'lucide-react';

type Props = {
    resolved: 'light' | 'dark' | null;
    onChange: (appearance: Appearance) => void;
};

export function WelcomeThemeToggle({ resolved, onChange }: Props) {
    const label =
        resolved === null
            ? 'Alternar tema'
            : resolved === 'dark'
              ? 'Ativar tema claro'
              : 'Ativar tema escuro';

    return (
        <button
            type="button"
            className="welcome-theme-toggle"
            aria-label={label}
            title={label}
            onClick={() => {
                const isDark =
                    resolved === 'dark' ||
                    (resolved === null &&
                        document.documentElement.classList.contains('dark'));
                onChange(isDark ? 'light' : 'dark');
            }}
        >
            <span className="welcome-theme-track" aria-hidden="true">
                <span className="welcome-theme-thumb">
                    <Sun className="welcome-theme-sun" />
                    <Moon className="welcome-theme-moon" />
                </span>
            </span>
        </button>
    );
}
